'use client';

import React, {useMemo} from 'react';
import {usePathname, useRouter, useSearchParams} from 'next/navigation';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {Button} from '@/components/ui/button';
import {ArrowUpDown} from 'lucide-react';

const SORT_OPTIONS = [
  {key: 'default', value: '', label: 'Популярные'},
  {key: 'price_asc', value: 'price_asc', label: 'Сначала дешевле'},
  {key: 'price_desc', value: 'price_desc', label: 'Сначала дороже'},
  {key: 'new', value: 'new', label: 'Новинки'},
];

export default function SortMenu({className = '', variant = 'flat', size = 'md', radius = 'lg'}) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentSort = searchParams.get('sort') ?? '';

  const currentOption = useMemo(() => {
    return SORT_OPTIONS.find((option) => option.value === currentSort) ?? SORT_OPTIONS[0];
  }, [currentSort]);

  const handleSelect = (key) => {
    const option = SORT_OPTIONS.find((item) => String(item.key) === String(key));
    if (!option) {
      return;
    }

    const params = new URLSearchParams(searchParams.toString());
    params.delete('page');

    if (option.value) {
      params.set('sort', option.value);
    } else {
      params.delete('sort');
    }

    const queryString = params.toString();
    router.replace(`${pathname}${queryString ? `?${queryString}` : ''}`, {scroll: false});
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant === 'flat' ? 'ghost' : variant || 'outline'}
          size={size || 'default'}
          className={`inline-flex items-center gap-2 ${className}`}
          aria-label="Изменить сортировку"
        >
          <ArrowUpDown className="h-4 w-4" />
          {currentOption.label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" aria-label="Сортировка товаров">
        {SORT_OPTIONS.map((option) => (
          <DropdownMenuItem 
            key={option.key} 
            className="text-sm"
            onClick={() => handleSelect(option.key)}
            data-selected={currentOption.key === option.key}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
